import React from "react";
import {Wrapper700, PaddingTopBottom30} from 'oolib'

export const DefaultContentBlocksWrapper = ({ children }) => (
  <Wrapper700>
    <PaddingTopBottom30>{children}</PaddingTopBottom30>
  </Wrapper700>
);
